/* IROKO — סקריפט הערכה. ללא תלויות. */
(function () {
  'use strict';
  var RTL = document.documentElement.getAttribute('dir') === 'rtl';

  /* ---------- חשיפה בגלילה ---------- */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' })
    : null;

  /* חשיפה כללית: סקשנים, כרטיסים, מדיה */
  function scanReveal() {
    if (!io) return;
    var sel = [
      ".rail__head", ".sec-head", ".prods__grid > *", ".cats__grid > *",
      ".split__i", ".band__in", ".story__grid > *", ".svc__i",
      ".club .wrap", ".colhero__in", ".look2__i", ".rail__track > .card"
    ].join(",");
    var i = 0;
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.classList.contains("reveal") || el.classList.contains("rise")) return;
      el.classList.add("reveal");
      var d = i % 4;
      if (d) el.classList.add("reveal-d" + d);
      i++;
      io.observe(el);
    });
    document.querySelectorAll(".hero__media, .band__m, .split__i, .colhero__m").forEach(function (el) {
      el.classList.add("zoomin");
      io.observe(el);
    });
  }

  function scanRise() {
    document.querySelectorAll('.rise:not(.in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('in');
    });
  }

  /* ---------- הדר: מצב גלילה ---------- */
  function header() {
    var hdr = document.querySelector('.hdr');
    if (!hdr) return;
    var raf = null;
    var sec = hdr.closest('.shopify-section');
    function paint() {
      raf = null;
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      var bar0 = hdr.querySelector('.hdr__bar');
      var ann = hdr.querySelector('.hdr__ann');
      var trip = ann ? ann.offsetHeight : 12;
      hdr.classList.toggle('stuck', y > trip);
      if (bar0) bar0.classList.toggle('stuck', y > trip);
      /* ההדר נדבק דרך עטיפת הסקשן, ומתכווץ אחרי קצת גלילה */
      if (sec) sec.classList.toggle('is-stuck', y > 40);
    }
    function onScroll() { if (raf === null) raf = requestAnimationFrame(paint); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    paint();

    // גובה ההדר -> משתנה CSS
    function measure() {
      /* במצב מכווץ לא מודדים, אחרת ההירו קופץ כששורת הכתובת בנייד משנה גובה */
      if (sec && sec.classList.contains('is-stuck')) return;
      var bar = hdr.querySelector('.hdr__bar');
      if (bar) {
        var hh = Math.round(bar.getBoundingClientRect().height);
        document.documentElement.style.setProperty('--header-h', hh + 'px');
        document.documentElement.style.setProperty('--navh', hh + 'px');
      }
    }
    measure();
    window.addEventListener('resize', measure, { passive: true });
  }

  /* ---------- הדר: הניווט אף פעם לא נכנס מתחת ללוגו ----------
     רוחב שבור לא יודע כמה ארוכים שמות התפריט. מודדים בפועל: פריט שלא נכנס
     עובר ל״עוד״, ואם גם זה לא מספיק — עוברים להמבורגר. */
  function navFit() {
    var hdr = document.querySelector('.hdr');
    var nav = hdr && hdr.querySelector('.hdr__nav');
    var brand = hdr && hdr.querySelector('.hdr__brand');
    if (!nav || !brand || nav.dataset.fit) return;
    nav.dataset.fit = '1';
    var more = nav.querySelector('.hdr__more');
    if (!more) {
      more = document.createElement('div');
      more.className = 'hdr__more';
      more.innerHTML = '<a href="#" aria-haspopup="true">עוד</a><div class="hdr__drop"></div>';
      nav.appendChild(more);
    }
    var drop = more.querySelector('.hdr__drop');
    var items = [].slice.call(nav.children).filter(function (el) { return el !== more; });
    more.querySelector('a').addEventListener('click', function (e) { e.preventDefault(); });

    function clash() {
      var b = brand.getBoundingClientRect();
      var s = nav.closest('.hdr__start').getBoundingClientRect();
      var pad = 18;
      return [].slice.call(nav.children).some(function (el) {
        if (el.classList.contains('nav-off') || !el.offsetWidth) return false;
        var r = el.getBoundingClientRect();
        return (r.left < b.right + pad && r.right > b.left - pad) || r.left < s.left - 1 || r.right > s.right + 1;
      });
    }
    function fit() {
      if (!nav.offsetParent && !hdr.classList.contains('hdr--burger')) return;
      hdr.classList.remove('hdr--burger');
      items.forEach(function (el) { el.classList.remove('nav-off'); });
      [].slice.call(drop.querySelectorAll('[data-nav-clone]')).forEach(function (a) { a.remove(); });
      more.classList.toggle('nav-off', !drop.children.length);
      if (!nav.offsetParent) return;
      var hidden = [];
      for (var i = items.length - 1; i >= 0 && clash(); i--) {
        items[i].classList.add('nav-off');
        hidden.unshift(items[i]);
        more.classList.remove('nav-off');
      }
      /* הפריטים שהוסתרו נכנסים לראש ״עוד״ בסדר המקורי */
      var first = drop.firstChild;
      hidden.forEach(function (el) {
        el.querySelectorAll('a').forEach(function (a, n) {
          var c = document.createElement('a');
          c.href = a.getAttribute('href');
          c.textContent = a.textContent;
          c.setAttribute('data-nav-clone', '');
          if (n > 0) c.className = 'hdr__drop-sub';
          drop.insertBefore(c, first);
        });
      });
      if (clash()) hdr.classList.add('hdr--burger');
    }
    var raf = null;
    function queue() { if (raf === null) raf = requestAnimationFrame(function () { raf = null; fit(); }); }
    fit();
    window.addEventListener('resize', queue, { passive: true });
    window.addEventListener('load', queue);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
  }

  /* ---------- רצועת הודעות מתחלפת במובייל ---------- */
  function announce() {
    var wrap = document.querySelector('.hdr__ann-in');
    if (!wrap) return;
    var items = wrap.querySelectorAll('span');
    if (items.length < 2) return;
    var mq = window.matchMedia('(max-width:1023px)');
    var i = 0, timer = null;
    function paint() { items.forEach(function (el, n) { el.classList.toggle('on', n === i); }); }
    function start() {
      if (!mq.matches) {
        if (timer) { clearInterval(timer); timer = null; }
        items.forEach(function (el) { el.classList.remove('on'); });
        return;
      }
      paint();
      if (timer) return;
      timer = setInterval(function () { i = (i + 1) % items.length; paint(); }, 4200);
    }
    start();
    mq.addEventListener('change', start);
  }

  /* ---------- מגירת ניווט ---------- */
  function drawer() {
    var d = document.querySelector('.drawer');
    if (!d) return;
    function open() { d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
    function close() { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    d.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- קרוסלות ---------- */
  function carousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('.row__track');
      if (!track) return;
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      function step() {
        var c = track.querySelector('.card');
        return c ? c.getBoundingClientRect().width + 14 : track.clientWidth * 0.8;
      }
      function paint() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        var x = Math.abs(track.scrollLeft);
        prev.disabled = x <= 2;
        next.disabled = x >= max;
      }
      function go(dir) { track.scrollBy({ left: (RTL ? -dir : dir) * step(), behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', paint, { passive: true });
      window.addEventListener('resize', paint, { passive: true });
      paint();
    });
  }

  /* ---------- תפריטים נפתחים בקולקציה ---------- */
  function drops() {
    document.addEventListener('click', function (e) {
      document.querySelectorAll('details.drop[open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    document.querySelectorAll('[data-filter]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var url = cb.getAttribute('data-url');
        if (url) window.location.href = url;
      });
    });
  }

  /* ---------- בורר וריאנטים ---------- */
  function product() {
    var root = document.querySelector('[data-pdp]');
    if (!root) return;
    var data = root.querySelector('[data-variants]');
    var variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-variant-id]');
    var atc = root.querySelector('[data-atc]');
    var atcText = root.querySelector('[data-atc-text]');
    var priceNow = root.querySelector('[data-price]');
    var priceWas = root.querySelector('[data-was]');
    var priceOff = root.querySelector('[data-off]');
    var offPre = priceOff ? priceOff.textContent.replace(/[0-9%]/g, '') : '-';
    function num(str) { return parseFloat(String(str).replace(/[^0-9.]/g, '')) || 0; }
    var L = {
      add: root.getAttribute('data-l-add') || 'הוספה לסל',
      sold: root.getAttribute('data-l-sold') || 'אזל מהמלאי',
      none: root.getAttribute('data-l-none') || 'הצירוף אינו זמין'
    };

    function optIndex(g, fallback) {
      var i = parseInt(g.getAttribute('data-opt-index'), 10);
      return isNaN(i) ? fallback : i;
    }
    function selected() {
      var out = [];
      root.querySelectorAll('[data-opt]').forEach(function (g, gi) {
        var on = g.querySelector('.chip[data-val].on');
        out[optIndex(g, gi)] = on ? on.getAttribute('data-val') : null;
      });
      for (var i = 0; i < out.length; i++) { if (out[i] === undefined) out[i] = null; }
      return out;
    }
    function match(sel) {
      return variants.filter(function (v) {
        return sel.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
    }
    function availability(sel) {
      root.querySelectorAll('[data-opt]').forEach(function (g, gi) {
        var oi = optIndex(g, gi);
        g.querySelectorAll('.chip[data-val]').forEach(function (chip) {
          var probe = sel.slice();
          probe[oi] = chip.getAttribute('data-val');
          var any = variants.some(function (v) {
            return v.available && probe.every(function (val, i) { return val === null || v.options[i] === val; });
          });
          chip.classList.toggle('off', !any);
        });
      });
    }
    function apply() {
      var sel = selected();
      root.querySelectorAll('[data-opt]').forEach(function (g, gi) {
        var out = g.querySelector('[data-opt-val]');
        if (out) out.textContent = sel[optIndex(g, gi)] || '';
      });
      availability(sel);
      document.dispatchEvent(new CustomEvent('iroko:variant'));
      var v = match(sel);
      if (!v) {
        if (atc) atc.disabled = true;
        if (atcText) atcText.textContent = L.none;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = v.price;
      if (priceWas) {
        if (v.compare) {
          priceWas.textContent = v.compare;
          priceWas.hidden = false;
          if (priceOff) {
            var c = num(v.compare), pnow = num(v.price);
            var pc = c > pnow ? Math.round((c - pnow) / c * 100) : 0;
            priceOff.textContent = offPre + pc + '%';
            priceOff.hidden = pc <= 0;
          }
        } else {
          priceWas.hidden = true;
          if (priceOff) priceOff.hidden = true;
        }
      }
      if (atc) atc.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? L.add : L.sold;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    }

    root.querySelectorAll('.chip[data-val]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.classList.contains('off')) return;
        var g = chip.closest('[data-opt]');
        g.querySelectorAll('.chip[data-val]').forEach(function (c) { c.classList.remove('on'); });
        chip.classList.add('on');
        apply();
      });
    });

    var gal = root.querySelector('.pdp__gal');
    var dots = root.querySelector('[data-pdp-dots]');
    var numEl = root.querySelector('[data-pdp-i]');
    if (gal && (dots || numEl)) {
      var raf = null;
      gal.addEventListener('scroll', function () {
        if (raf !== null) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var w = gal.clientWidth || 1;
          var i = Math.round(Math.abs(gal.scrollLeft) / w);
          if (dots) dots.querySelectorAll('i').forEach(function (d, n) { d.classList.toggle('on', n === i); });
          if (numEl) numEl.textContent = i + 1;
        });
      }, { passive: true });
    }
    apply();
  }

  /* ---------- בוררי כמות ---------- */
  function quantities() {
    document.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('input');
        var n = parseInt(input.value || '1', 10);
        n = b.getAttribute('data-qty') === '+' ? n + 1 : Math.max(parseInt(input.min || '1', 10), n - 1);
        input.value = n;
        if (input.form && input.hasAttribute('data-autosubmit')) input.form.submit();
      });
    });
  }

  /* ---------- פרלקסה ----------
     הקודמת הזיזה את התמונה עצמה, שהיה עליה מעבר CSS של 1.6 שניות,
     ולכן כל תזוזה נגררה אחרי הגלילה. עכשיו שכבה עוטפת זזה ישירות עם הגלילה,
     בטווח קטן, והתמונה לא נוגעת. */
  function parallax() {
    var hosts = [].slice.call(document.querySelectorAll(".hero__media[data-px], .band__m[data-px]"));
    if (!hosts.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var html = document.documentElement;
    var items = hosts.map(function (host) {
      var layer = host.querySelector(".px-layer");
      if (!layer) {
        layer = document.createElement("div");
        layer.className = "px-layer";
        while (host.firstChild) layer.appendChild(host.firstChild);
        host.appendChild(layer);
      }
      return { host: host, layer: layer };
    });
    var raf = null;
    function paint() {
      raf = null;
      if (html.classList.contains("a11y-motion")) {
        items.forEach(function (it) { it.layer.style.transform = ""; });
        return;
      }
      var vh = window.innerHeight || 800;
      items.forEach(function (it) {
        var r = it.host.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        /* 0 כשהאלמנט נכנס מלמטה, 1 כשהוא יוצא למעלה */
        var t = (vh - r.top) / (vh + r.height);
        var y = (t - 0.5) * r.height * 0.14;
        it.layer.style.transform = "translate3d(0," + y.toFixed(1) + "px,0)";
      });
    }
    function onScroll() { if (raf === null) raf = requestAnimationFrame(paint); }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    paint();
  }

  /* ---------- פרקים: החלפת המדיה הננעצת ---------- */
  function chapters() {
    document.querySelectorAll("[data-chapters]").forEach(function (root) {
      var items = root.querySelectorAll("[data-chapter]");
      var media = root.querySelectorAll("[data-chapter-media]");
      if (!items.length || !media.length) return;
      var obs = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = e.target.getAttribute("data-chapter");
          media.forEach(function (m) {
            m.classList.toggle("on", m.getAttribute("data-chapter-media") === i);
          });
        });
      }, { rootMargin: "-45% 0px -45% 0px", threshold: 0 });
      items.forEach(function (it) { obs.observe(it); });
    });
  }

  /* ---------- הוספה מהירה מהכרטיס ---------- */
  function quickAdd() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-quick-add]");
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var id = btn.getAttribute("data-quick-add");
      var old = btn.textContent;
      btn.textContent = "…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = old;
          if (CD) { CD.refresh().then(function () { CD.open(); }); }
          else window.location.href = "/cart";
        })
        .catch(function () { btn.textContent = old; });
    });
  }

  /* ---------- מועדפים: לב ייחודי לכל מוצר, נשמר בדפדפן ---------- */
  var WISH_KEY = "iroko_wish";
  function wishRead() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || "[]"); } catch (e) { return []; }
  }
  function wishWrite(arr) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function wishlist() {
    function paint() {
      var list = wishRead();
      document.querySelectorAll("[data-wish]").forEach(function (b) {
        b.classList.toggle("on", list.indexOf(b.getAttribute("data-wish")) > -1);
      });
      var n = document.querySelector("[data-wish-count]");
      if (n) {
        n.textContent = list.length;
        n.style.display = list.length ? "" : "none";
      }
      // עמוד המועדפים: מציג רק את מה ששמור
      var page = document.querySelector("[data-wish-page]");
      if (page) {
        var shown = 0;
        page.querySelectorAll("[data-wish-item]").forEach(function (el) {
          var on = list.indexOf(el.getAttribute("data-wish-item")) > -1;
          el.style.display = on ? "" : "none";
          if (on) shown++;
        });
        var empty = document.querySelector("[data-wish-empty]");
        if (empty) empty.style.display = shown ? "none" : "";
        var grid = page.querySelector(".prods__grid");
        if (grid) grid.style.display = shown ? "" : "none";
      }
    }
    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-wish]");
      if (!b) return;
      e.preventDefault();
      var h = b.getAttribute("data-wish");
      var list = wishRead();
      var i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.push(h);
      wishWrite(list);
      paint();
      toast(i > -1 ? "הוסר מהמועדפים" : "נשמר במועדפים");
    });
    paint();
  }

  /* ---------- שורות נגללות + טאבים ---------- */
  function rails() {
    document.querySelectorAll("[data-rail]").forEach(function (root) {
      var tabs = root.querySelectorAll("[data-rail-tab]");
      var panes = root.querySelectorAll("[data-rail-pane]");
      var prev = root.querySelector("[data-rail-prev]");
      var next = root.querySelector("[data-rail-next]");

      function track() {
        var on = root.querySelector(".rail__pane.on") || root;
        return on.querySelector(".rail__track");
      }
      function step() {
        var t = track(); if (!t) return 0;
        var c = t.querySelector(".card");
        return c ? c.getBoundingClientRect().width + 10 : t.clientWidth * 0.8;
      }
      function paint() {
        var t = track(); if (!t || !prev || !next) return;
        var max = t.scrollWidth - t.clientWidth - 2;
        var x = Math.abs(t.scrollLeft);
        prev.disabled = x <= 2;
        next.disabled = x >= max;
      }
      function go(dir) {
        var t = track(); if (!t) return;
        t.scrollBy({ left: (RTL ? -dir : dir) * step(), behavior: "smooth" });
      }
      if (prev) prev.addEventListener("click", function () { go(-1); });
      if (next) next.addEventListener("click", function () { go(1); });
      root.querySelectorAll(".rail__track").forEach(function (t) {
        t.addEventListener("scroll", paint, { passive: true });
      });
      window.addEventListener("resize", paint, { passive: true });

      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          var i = tab.getAttribute("data-rail-tab");
          tabs.forEach(function (x) { x.classList.toggle("on", x === tab); });
          panes.forEach(function (pn) { pn.classList.toggle("on", pn.getAttribute("data-rail-pane") === i); });
          requestAnimationFrame(function () { var t = track(); if (t) t.scrollLeft = 0; paint(); });
        });
      });

      requestAnimationFrame(function () {
        root.querySelectorAll(".rail__track").forEach(function (t) { t.scrollLeft = 0; });
        paint();
      });
    });
  }

  /* ---------- מונה מתעניינים (מספר אקראי, לא נתון אמיתי) ---------- */
  function liveCount() {
    var els = document.querySelectorAll("[data-live]");
    if (!els.length) return;
    var host = document.querySelector("[data-live-range]");
    var min = parseInt((host && host.getAttribute("data-live-min")) || "14", 10);
    var max = parseInt((host && host.getAttribute("data-live-max")) || "47", 10);
    var hot = parseInt((host && host.getAttribute("data-live-hot")) || "0", 10);
    if (max <= min) max = min + 12;
    var n = min + Math.floor(Math.random() * (max - min + 1));
    function paint() {
      els.forEach(function (el) {
        el.textContent = n;
        el.classList.remove("bump");
        void el.offsetWidth;
        el.classList.add("bump");
      });
      if (host && hot > 0) host.classList.toggle("hot", n >= hot);
    }
    paint();
    (function tick() {
      setTimeout(function () {
        var jump = 1 + Math.floor(Math.random() * 3);
        var d = Math.random() < 0.5 ? -jump : jump;
        n = Math.min(max, Math.max(min, n + d));
        paint();
        tick();
      }, 2200 + Math.floor(Math.random() * 2200));
    })();
  }

  /* ---------- אפ-סייל: סכום + הוספת הכל ---------- */
  function bundle() {
    var box = document.querySelector("[data-bundle-box]");
    if (!box) return;
    var base = parseInt(box.getAttribute("data-base") || "0", 10);
    var totalEl = box.querySelector("[data-bundle-total]");
    var addBtn = box.querySelector("[data-bundle-add]");
    var boxes = box.querySelectorAll("[data-bundle]");
    var subEl = box.querySelector("[data-bundle-sub]");
    var discRow = box.querySelector("[data-bundle-disc]");
    var discName = box.querySelector("[data-bundle-disc-name]");
    var discAmt = box.querySelector("[data-bundle-disc-amt]");
    function fmt(cents) {
      var v = cents / 100;
      return "₪" + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
    }
    var num = function (a, dflt) { var v = parseFloat(box.getAttribute(a)); return isNaN(v) ? dflt : v; };
    var T = [
      { min: num("data-t1-min", 2), pct: num("data-t1-pct", 0) },
      { min: num("data-t2-min", 0), pct: num("data-t2-pct", 0) }
    ].filter(function (x) { return x.min >= 2 && x.pct > 0; })
     .sort(function (a, b) { return a.min - b.min; });
    var MSG = {
      next: box.getAttribute("data-t-next") || "עוד [n] פריטים ואתם מקבלים [pct]% הנחה",
      hit: box.getAttribute("data-t-hit") || "[pct]% הנחה הופעלו",
      top: box.getAttribute("data-t-top") || "אתם בהנחה הגבוהה ביותר, [pct]%"
    };
    var fillEl = box.querySelector("[data-tiers-fill]");
    var marksEl = box.querySelector("[data-tiers-marks]");
    var msgEl = box.querySelector("[data-tiers-msg]");
    var tiersEl = box.querySelector("[data-tiers]");
    if (tiersEl && !T.length) tiersEl.hidden = true;

    function say(tpl, n, pct) {
      var one = n === 1;
      return String(tpl)
        .replace("[n]", one ? "פריט אחד" : n + " פריטים")
        .replace("[pct]", pct);
    }
    function tierFor(n) {
      var hit = null;
      T.forEach(function (t) { if (n >= t.min) hit = t; });
      return hit;
    }
    function nextTier(n) {
      for (var i = 0; i < T.length; i++) { if (n < T[i].min) return T[i]; }
      return null;
    }
    if (marksEl && T.length) {
      var cap = T[T.length - 1].min;
      marksEl.innerHTML = T.map(function (t) {
        return '<span style="inset-inline-start:' + Math.round(t.min / cap * 100) + '%" data-mark="' + t.min + '"><b>' + t.pct + '%</b><i>' + t.min + '</i></span>';
      }).join("");
    }

    function paint() {
      var sum = base, n = 1;
      boxes.forEach(function (b) {
        if (b.checked) { sum += parseInt(b.getAttribute("data-price") || "0", 10); n++; }
      });
      var cur = tierFor(n), nxt = nextTier(n);
      var pct = cur ? cur.pct : 0;
      var save = pct > 0 ? Math.round(sum * pct / 100) : 0;

      if (subEl) subEl.textContent = fmt(sum);
      if (discRow) {
        discRow.hidden = save === 0;
        if (discName) discName.textContent = (cur ? cur.pct + "% " : "") + (discLabel || "הנחת כמות");
        if (discAmt) discAmt.textContent = "\u2212" + fmt(save);
      }
      if (totalEl) totalEl.textContent = fmt(sum - save);

      if (T.length) {
        var cap2 = T[T.length - 1].min;
        if (fillEl) fillEl.style.width = Math.min(100, n / cap2 * 100) + "%";
        if (marksEl) marksEl.querySelectorAll("[data-mark]").forEach(function (m) {
          m.classList.toggle("on", n >= parseInt(m.getAttribute("data-mark"), 10));
        });
        if (msgEl) {
          if (nxt) msgEl.textContent = say(MSG.next, nxt.min - n, nxt.pct);
          else if (cur) msgEl.textContent = say(T.length > 1 ? MSG.top : MSG.hit, 0, cur.pct);
          msgEl.classList.toggle("hit", !nxt && !!cur);
        }
      }
    }
    var discLabel = box.getAttribute("data-bundle-label") || "הנחת כמות";
    boxes.forEach(function (b) { b.addEventListener("change", paint); });
    paint();
    if (addBtn) {
      addBtn.addEventListener("click", function () {
        var items = [];
        var hidden = document.querySelector("[data-variant-id]");
        items.push({ id: Number(hidden ? hidden.value : addBtn.getAttribute("data-main")), quantity: 1 });
        boxes.forEach(function (b) { if (b.checked) items.push({ id: Number(b.getAttribute("data-bundle")), quantity: 1 }); });
        var old = addBtn.textContent;
        addBtn.textContent = "��";
        fetch("/cart/add.js", {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); })
          .then(function () {
            addBtn.textContent = old;
            if (CD) { CD.refresh().then(function () { CD.open(); }); }
            else window.location.href = "/cart";
          })
          .catch(function () { addBtn.textContent = old; });
      });
    }
  }

  /* ---------- סרגל קנייה דביק במובייל ---------- */
  function stickyBar() {
    var btn = document.querySelector("[data-stick-atc]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var atc = document.querySelector("[data-atc]");
      if (atc) atc.click();
    });
    var price = document.querySelector("[data-price]");
    var out = document.querySelector("[data-stick-price]");
    if (price && out) {
      new MutationObserver(function () { out.textContent = price.textContent; })
        .observe(price, { childList: true, characterData: true, subtree: true });
    }
  }

  /* ---------- מוצא מידות ----------
     הטבלאות הן של Polo Ralph Lauren לדגם עצמו (BODY + PRODUCT), מתוך
     assets/iroko-sizecharts.js. מי שמודד היקף חזה מקבל התאמה ישירה מהטבלה;
     גובה ומשקל הם הערכה בלבד, וכך גם נאמר בחלונית. */
  function sfNum(v) {
    /* "96.5" או "89.0-94" -> מספר; בטווח לוקחים את האמצע */
    if (v == null) return NaN;
    var a = String(v).replace(/[^\d.\-]/g, "").split("-").filter(Boolean)
      .map(parseFloat).filter(function (x) { return !isNaN(x); });
    if (!a.length) return NaN;
    return a.length > 1 ? (a[0] + a[1]) / 2 : a[0];
  }
  function sfCol(tbl, names) {
    if (!tbl || !tbl.cols) return -1;
    for (var i = 0; i < tbl.cols.length; i++) {
      var c = String(tbl.cols[i]).toUpperCase();
      for (var j = 0; j < names.length; j++) if (c.indexOf(names[j]) === 0) return i;
    }
    return -1;
  }
  /* בד וגזרות של הפריט הנוכחי, מתוך אפשרויות הווריאנטים ("M slim / Unisex / Linen") */
  function sfProduct() {
    var el = document.querySelector("[data-variants]");
    var out = { fabric: "", fits: [] };
    if (!el) return out;
    var list;
    try { list = JSON.parse(el.textContent); } catch (e) { return out; }
    (list || []).forEach(function (v) {
      /* הווריאנטים מגיעים כ-options: ["M slim","Unisex","Oxford"] */
      var op = v.options && v.options.length ? v.options
        : String(v.title || "").split("/").map(function (x) { return x.trim(); });
      var last = String(op[op.length - 1] || "").trim().toLowerCase();
      if (last && !out.fabric) out.fabric = last;
      var fit = String(op[0] || "").trim().split(" ").slice(1).join(" ").toLowerCase();
      if (fit && out.fits.indexOf(fit) < 0) out.fits.push(fit);
    });
    return out;
  }
  function sfChart(fabric, fit, gender) {
    var S = window.IROKO_SIZES;
    if (!S || !S.map) return null;
    var keys = [fabric + "|" + fit + "|" + gender, fabric + "||" + gender,
                fabric + "|" + fit + "|m", fabric + "||m"];
    for (var i = 0; i < keys.length; i++) {
      var k = S.map[keys[i]];
      if (k && S.charts[k]) return S.charts[k];
    }
    return null;
  }
  /* הערכת היקף חזה מגובה ומשקל. מכוילת למבנה גוף ממוצע (175/75 -> ~99 ס"מ),
     ולכן היא קירוב ולא מדידה — הכיתוב בחלונית אומר את זה במפורש. */
  function sfChest(h, w, gender) {
    return Math.round((0.53 * w + 0.29 * h + (gender === "f" ? 8.0 : 8.5)) * 10) / 10;
  }
  /* חלק מהטבלאות מסמנות מידה כמספר EU. הטבלה של אותו דגם מחזיקה גם את האות,
     ולכן ממירים לפי EU במקום לנחש. */
  function sfLetter(chart, label) {
    var raw = String(label == null ? "" : label);
    if (/[A-Za-z֐-׿]{1,4}$/.test(raw.replace(/^EU\s*/i, "")) && !/^\s*EU/i.test(raw) && /[A-Za-z]/.test(raw)) return raw;
    var n = parseFloat(raw.replace(/[^\d.]/g, ""));
    if (isNaN(n)) return raw;
    var b = chart.body, ei = sfCol(b, ["EU"]), si = sfCol(b, ["SIZE"]);
    if (b && ei >= 0 && si >= 0) {
      for (var i = 0; i < b.rows.length; i++) {
        if (parseFloat(String(b.rows[i][ei]).replace(/[^\d.]/g, "")) === n) return b.rows[i][si];
      }
    }
    return raw;
  }
  function sfPick(chart, chest, fit) {
    var S = window.IROKO_SIZES || {};
    var add = (S.ease && S.ease[fit] != null) ? S.ease[fit] : 10;
    var t = chart.product, ci = sfCol(t, ["CHEST", "BUST"]), si = sfCol(t, ["SIZE"]);
    var rows = (t && t.rows) || [], i, v, row;
    if (t && ci >= 0 && rows.length) {
      for (i = 0; i < rows.length; i++) {
        v = sfNum(rows[i][ci]);
        if (!isNaN(v) && v >= chest + add) {
          return { size: sfLetter(chart, rows[i][si >= 0 ? si : 0]), garment: v, ease: add };
        }
      }
      row = rows[rows.length - 1];
      return { size: sfLetter(chart, row[si >= 0 ? si : 0]), garment: sfNum(row[ci]), ease: add, over: true };
    }
    /* אין טבלת בגד: בוחרים מתוך טבלת הגוף */
    var b = chart.body, bi = sfCol(b, ["CHEST", "BUST"]), bs = sfCol(b, ["SIZE"]);
    var brows = (b && b.rows) || [];
    for (i = 0; i < brows.length; i++) {
      v = sfNum(brows[i][bi]);
      if (!isNaN(v) && v >= chest) {
        return { size: sfLetter(chart, bs >= 0 ? brows[i][bs] : brows[i][0]), body: v, ease: 0 };
      }
    }
    if (brows.length) {
      row = brows[brows.length - 1];
      return { size: sfLetter(chart, bs >= 0 ? row[bs] : row[0]), body: sfNum(row[bi]), ease: 0, over: true };
    }
    return null;
  }
  function sfTable(tbl) {
    if (!tbl || !tbl.rows || !tbl.rows.length) return "";
    var h = "<table class='sfc__tb'><thead><tr>";
    tbl.cols.forEach(function (c) { h += "<th>" + String(c).replace(/[<>]/g, "") + "</th>"; });
    h += "</tr></thead><tbody>";
    tbl.rows.forEach(function (r) {
      h += "<tr>";
      r.forEach(function (c, n) {
        h += (n === 0 ? "<th scope='row'>" : "<td>") + String(c).replace(/[<>"']/g, "") + (n === 0 ? "</th>" : "</td>");
      });
      h += "</tr>";
    });
    return h + "</tbody></table>";
  }

  function sizeFinder() {
    var modal = document.querySelector("[data-sf]");
    if (!modal) return;
    var info = sfProduct();
    var gender = "m";
    /* הפריטים בחנות הם Unisex בגזרת גברים. המגדר בטופס משנה רק את הערכת היקף החזה,
       והטבלה נשארת של הדגם עצמו, אלא אם הכותרת אומרת שזה פריט נשים. */
    var titleEl = document.querySelector(".pdp__title");
    var prodGender = titleEl && /נשים|לנשים/.test(titleEl.textContent) ? "f" : "m";
    var fitIdx = 0;
    var FITS = ["slim", "", "classic"];   /* צמוד / רגיל / רחב, כשאין גזרה בפריט */

    function curFit() {
      if (info.fits.length === 1) return info.fits[0];
      var chip = document.querySelector("[data-opt] .chip.on");
      var val = chip ? (chip.getAttribute("data-val") || "") : "";
      var f = val.split(" ").slice(1).join(" ").toLowerCase();
      if (f) return f;
      return FITS[fitIdx + 1] != null ? FITS[fitIdx + 1] : "";
    }

    function seg(sel, cb) {
      var box = modal.querySelector(sel);
      if (!box) return;
      box.querySelectorAll("button").forEach(function (b) {
        b.addEventListener("click", function () {
          box.querySelectorAll("button").forEach(function (x) { x.classList.remove("on"); });
          b.classList.add("on");
          cb(b.getAttribute("data-v"));
        });
      });
    }
    seg("[data-sf-gender]", function (v) { gender = v; paintTable(); });
    seg("[data-sf-fit]", function (v) { fitIdx = parseInt(v, 10); paintTable(); });

    /* הטבלה של הדגם עצמו, בתוך החלונית */
    var tableBox = modal.querySelector("[data-sf-table]");
    var tableTitle = modal.querySelector("[data-sf-table-title]");
    function paintTable() {
      if (!tableBox) return;
      var chart = sfChart(info.fabric, curFit(), prodGender);
      if (!chart) { tableBox.innerHTML = ""; if (tableTitle) tableTitle.textContent = ""; return; }
      if (tableTitle) tableTitle.textContent = chart.en || chart.he || "";
      var body = sfTable(chart.body), prod = sfTable(chart.product);
      tableBox.innerHTML =
        (body ? "<p class='sfc__h'>מידות גוף (ס\"מ)</p>" + body : "") +
        (prod ? "<p class='sfc__h'>מידות הבגד (ס\"מ)</p>" + prod : "");
    }

    function open() { modal.classList.add("open"); modal.setAttribute("aria-hidden", "false"); paintTable(); }
    function close() { modal.classList.remove("open"); modal.setAttribute("aria-hidden", "true"); }
    document.querySelectorAll("[data-sf-open]").forEach(function (b) { b.addEventListener("click", open); });
    modal.querySelectorAll("[data-sf-close]").forEach(function (b) { b.addEventListener("click", close); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

    modal.querySelector("[data-sf-go]").addEventListener("click", function () {
      var h = parseFloat((modal.querySelector("[data-sf-h]") || {}).value);
      var w = parseFloat((modal.querySelector("[data-sf-w]") || {}).value);
      var c = parseFloat((modal.querySelector("[data-sf-c]") || {}).value);
      var out = modal.querySelector("[data-sf-out]");
      var sizeEl = modal.querySelector("[data-sf-size]");
      var noteEl = modal.querySelector("[data-sf-note]");
      var measured = !!(c && c >= 60 && c <= 160);
      if (!measured && (!h || !w || h < 130 || h > 215 || w < 35 || w > 180)) {
        out.classList.add("on");
        sizeEl.textContent = "?";
        noteEl.textContent = "מלאו גובה ומשקל, או היקף חזה אם מדדתם.";
        return;
      }
      var fit = curFit();
      var chart = sfChart(info.fabric, fit, prodGender);
      var chest = measured ? c : sfChest(h, w, gender);
      var res = chart ? sfPick(chart, chest, fit) : null;
      out.classList.add("on");

      if (!res) {   /* אין טבלה לדגם הזה: לא ממציאים, שולחים למדוד */
        sizeEl.textContent = "?";
        noteEl.textContent = "אין לנו טבלת מידות לדגם הזה. אפשר לכתוב לנו בוואטסאפ ונבדוק מולכם.";
        return;
      }
      var size = String(res.size).toUpperCase().replace(/^EU\s*/, "");
      sizeEl.textContent = size;
      var txt = measured
        ? "לפי היקף חזה " + chest + " ס\"מ"
        : "היקף חזה משוער " + chest + " ס\"מ (הערכה מגובה ומשקל, לא מדידה)";
      if (res.garment) txt += ", והיקף החזה של הבגד במידה הזו הוא " + res.garment + " ס\"מ.";
      else if (res.body) txt += ", ומידה זו בטבלת היצרן היא " + res.body + " ס\"מ.";
      else txt += ".";
      if (res.over) txt += " זו המידה הגדולה ביותר בדגם.";
      noteEl.textContent = txt + " אם אתם בין מידות, כדאי לבחור את הגדולה.";

      /* סימון המידה בבורר, וכפתור שבוחר אותה בפועל */
      var target = null;
      document.querySelectorAll("[data-opt] .chip").forEach(function (chip) {
        var v = (chip.getAttribute("data-val") || "").toUpperCase();
        chip.style.outline = "";
        if (v === size || v.indexOf(size + " ") === 0) {
          chip.style.outline = "2px solid var(--ink)";
          chip.style.outlineOffset = "2px";
          if (!chip.classList.contains("off")) target = chip;
        }
      });
      var useBtn = modal.querySelector("[data-sf-use]");
      if (useBtn) {
        useBtn.hidden = !target;
        useBtn.onclick = function () {
          if (!target) return;
          target.click();
          close();
          document.body.classList.remove("noscroll");
          var el = document.querySelector(".opt--size");
          if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        };
      }
      if (!target) noteEl.textContent += " המידה הזו לא זמינה כרגע בפריט הזה.";
    });
  }

  /* ---------- הודעת אישור קצרה ---------- */
  var toastEl = null, toastT = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "toast";
      toastEl.innerHTML = "<b></b>";
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector("b").textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add("on"); });
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove("on"); }, 2200);
  }

  /* ---------- גלריה בכרטיס ---------- */
  function cardLabel(btn, on) {
    var sp = btn.querySelector("[data-card-label]");
    if (!sp) return;
    var t = on ? btn.getAttribute("data-label-on") : btn.getAttribute("data-label-off");
    if (t) sp.textContent = t;
  }
  function galDir(g) { return getComputedStyle(g).direction === "rtl" ? -1 : 1; }
  function galIndex(g) { var w = g.clientWidth || 1; return Math.round(Math.abs(g.scrollLeft) / w); }
  function galPaint(card, i) {
    var g = card.querySelector("[data-card-gal]");
    if (!g) return;
    if (typeof i !== "number") i = galIndex(g);
    var max = g.children.length - 1;
    card.querySelectorAll(".card__dots i, .card__led i").forEach(function (d, n) { d.classList.toggle("on", n === i); });
    /* רק התמונה הנוכחית גלויה במנוחה, אחרת מציץ פס מהשכנה בקצה */
    card.querySelectorAll(".card__slide").forEach(function (sl, n) { sl.classList.toggle("cur", n === i); });
    card.querySelectorAll("[data-gal-step]").forEach(function (b) {
      b.disabled = parseInt(b.getAttribute("data-gal-step"), 10) < 0 ? i <= 0 : i >= max;
    });
    card.querySelectorAll("[data-card-view][data-idx]").forEach(function (x) {
      var on = i > 0 && parseInt(x.getAttribute("data-idx"), 10) === i;
      x.classList.toggle("on", on);
      cardLabel(x, on);
    });
  }
  function galGo(card, i) {
    var g = card.querySelector("[data-card-gal]");
    if (!g) return;
    i = Math.max(0, Math.min(g.children.length - 1, i));
    g.scrollTo({ left: galDir(g) * i * g.clientWidth, behavior: "smooth" });
    galPaint(card, i);
  }
  function cardGallery() {
    document.querySelectorAll("[data-card-gal]").forEach(function (g) {
      var card = g.closest("[data-card]");
      if (!card) return;
      var raf = null, idle = null;
      g.addEventListener("scroll", function () {
        g.classList.add("gal-move");
        clearTimeout(idle);
        idle = setTimeout(function () { g.classList.remove("gal-move"); galPaint(card); }, 170);
        if (raf !== null) return;
        raf = requestAnimationFrame(function () { raf = null; galPaint(card); });
      }, { passive: true });
      g.scrollLeft = 0;
      galPaint(card, 0);
    });
    document.addEventListener("click", function (e) {
      var st = e.target.closest("[data-gal-step]");
      if (!st) return;
      e.preventDefault();
      e.stopPropagation();
      var card = st.closest("[data-card]");
      var g = card && card.querySelector("[data-card-gal]");
      if (g) galGo(card, galIndex(g) + parseInt(st.getAttribute("data-gal-step"), 10));
    });
  }

  /* ---------- החלקה בין תמונות בכרטיס שבתוך שורה אופקית ----------
     הכיוון נקבע בתנועה הראשונה: אופקית = מחליפים תמונה, אנכית = גלילת הדף.
     בתמונה האחרונה (או הראשונה) ההחלקה עוברת לשורה עצמה. */
  function railSwipe() {
    document.querySelectorAll(".rail [data-card-gal]").forEach(function (g) {
      if (g.dataset.swipe) return;
      g.dataset.swipe = "1";
      var card = g.closest("[data-card]");
      if (!card || g.children.length < 2) return;
      var sx = 0, sy = 0, s0 = 0, i0 = 0, w = 1, mode = 0;
      function stepFor(dx) { return (dx < 0 ? 1 : -1) * (galDir(g) === -1 ? -1 : 1); }
      g.addEventListener("touchstart", function (e) {
        var t = e.touches[0];
        sx = t.clientX; sy = t.clientY; s0 = g.scrollLeft; i0 = galIndex(g); w = g.clientWidth || 1; mode = 0;
      }, { passive: true });
      g.addEventListener("touchmove", function (e) {
        if (mode === -1 || e.touches.length > 1) return;
        var t = e.touches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (mode === 0) {
          if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
          if (Math.abs(dy) >= Math.abs(dx)) { mode = -1; return; }
          var to = i0 + stepFor(dx);
          if (to < 0 || to > g.children.length - 1) { mode = -1; return; }
          mode = 1;
        }
        if (e.cancelable) e.preventDefault();
        g.scrollLeft = s0 - dx;
      }, { passive: false });
      g.addEventListener("touchend", function (e) {
        if (mode !== 1) { mode = 0; return; }
        var dx = e.changedTouches[0].clientX - sx;
        galGo(card, Math.abs(dx) > w * 0.16 ? i0 + stepFor(dx) : i0);
        card.dataset.swiped = String(Date.now());
        mode = 0;
      });
    });
    if (window.__irkSwipeClick) return;
    window.__irkSwipeClick = true;
    /* הלחיצה שהדפדפן שולח בסוף החלקה לא פותחת את דף המוצר */
    document.addEventListener("click", function (e) {
      var c = e.target.closest(".rail [data-card]");
      if (c && c.dataset.swiped && Date.now() - Number(c.dataset.swiped) < 450) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  /* ---------- לשוניות גברים / נשים בדף המוצר ----------
     הגלריה בדף המוצר היא שורה נגללת בנייד וגריד בדסקטופ, ולכן הקפיצה
     נעשית ב-scrollIntoView ולא בחישוב scrollLeft: ב-RTL הוא שלילי. */
  function pdpViews() {
    var sw = document.querySelector('[data-pdp-switch]');
    if (!sw) return;
    var gal = document.querySelector('.pdp__gal');
    if (!gal) return;
    function label(btn, on) {
      var sp = btn.querySelector('[data-pdp-label]');
      if (!sp) return;
      var t = on ? btn.getAttribute('data-label-on') : btn.getAttribute('data-label-off');
      if (t) sp.textContent = t;
    }
    function go(i) {
      var el = gal.children[i];
      if (!el) return;
      var horiz = gal.scrollWidth > gal.clientWidth + 4;
      el.scrollIntoView(horiz
        ? { behavior: 'smooth', inline: 'center', block: 'nearest' }
        : { behavior: 'smooth', block: 'center' });
    }
    sw.querySelectorAll('[data-pdp-view][data-idx]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var was = btn.classList.contains('on');
        sw.querySelectorAll('[data-pdp-view]').forEach(function (o) {
          o.classList.remove('on');
          label(o, false);
        });
        if (was) { go(0); return; }
        btn.classList.add('on');
        label(btn, true);
        go(parseInt(btn.getAttribute('data-idx'), 10) || 0);
      });
    });
    /* גלילה ידנית מחזירה את הלשוניות למצב מנוחה */
    var raf = null;
    gal.addEventListener('scroll', function () {
      if (raf !== null) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = gal.clientWidth || 1;
        var i = Math.round(Math.abs(gal.scrollLeft) / w);
        sw.querySelectorAll('[data-pdp-view][data-idx]').forEach(function (btn) {
          var on = i > 0 && parseInt(btn.getAttribute('data-idx'), 10) === i;
          btn.classList.toggle('on', on);
          label(btn, on);
        });
      });
    }, { passive: true });
  }

  /* ---------- לשוניות גברים / נשים: קופצות לצילום בגלריה ---------- */
  function viewToggle() {
    document.addEventListener("click", function (e) {
      var seg = e.target.closest("[data-card-view]");
      if (!seg || seg.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var card = seg.closest("[data-card]");
      if (!card) return;
      /* לחיצה על הלשונית הפעילה = חזרה לצילום הבגד */
      if (seg.classList.contains("on")) { galGo(card, 0); return; }
      galGo(card, parseInt(seg.getAttribute("data-idx"), 10) || 0);
    });
  }

  /* ---------- פופ-אפ פתיחה ---------- */
  function popup() {
    var el = document.querySelector("[data-pop]");
    if (!el) return;
    var key = "iroko_pop_" + (el.getAttribute("data-pop-v") || "1");
    var days = parseInt(el.getAttribute("data-pop-days") || "7", 10);
    /* אחרי הרשמה שופיפיי טוענת את הדף מחדש. בלי אישור הלקוח לא יודע שזה עבד */
    if (/[?&]customer_posted=true/.test(window.location.search)) {
      try { localStorage.setItem(key, String(Date.now())); } catch (e) {}
      setTimeout(function () { toast(el.getAttribute("data-pop-ok") || "נרשמתם. נעדכן לפני הדרופ הבא."); }, 500);
      return;
    }
    el.addEventListener("submit", function () {
      try { localStorage.setItem(key, String(Date.now())); } catch (e) {}
    });
    try {
      var seen = parseInt(localStorage.getItem(key) || "0", 10);
      if (seen && Date.now() - seen < days * 864e5) return;
    } catch (e) {}
    var delay = parseInt(el.getAttribute("data-pop-delay") || "5", 10) * 1000;

    function close() {
      el.classList.remove("on");
      try { localStorage.setItem(key, String(Date.now())); } catch (e) {}
    }
    setTimeout(function () {
      el.classList.add("on");
      document.dispatchEvent(new CustomEvent("iroko:pop"));
    }, delay);

    el.addEventListener("click", function (e) {
      if (e.target === el || e.target.closest("[data-pop-close]")) { e.preventDefault(); close(); }
      var c = e.target.closest("[data-pop-code]");
      if (c) {
        var code = c.getAttribute("data-pop-code");
        if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {});
        toast("הקוד " + code + " הועתק");
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && el.classList.contains("on")) close();
    });

    /* טיימר לדרופ */
    var t = el.querySelector("[data-pop-timer]");
    if (t) {
      var end = new Date(t.getAttribute("data-pop-timer")).getTime();
      if (!isNaN(end)) {
        (function run() {
          var left = Math.max(0, end - Date.now());
          var d = Math.floor(left / 864e5),
              h = Math.floor(left / 36e5) % 24,
              m = Math.floor(left / 6e4) % 60,
              s = Math.floor(left / 1e3) % 60;
          var out = [d, h, m, s];
          t.querySelectorAll("b").forEach(function (b, i) {
            b.textContent = out[i] < 10 ? "0" + out[i] : String(out[i]);
          });
          if (left > 0) setTimeout(run, 1000);
        })();
      }
    }
  }

  /* ---------- טאבים לתוכן חשוב ---------- */
  function tabs() {
    document.querySelectorAll("[data-tabs]").forEach(function (root) {
      var btns = root.querySelectorAll("[data-tab]");
      var panes = root.querySelectorAll("[data-pane]");
      root.addEventListener("click", function (e) {
        var b = e.target.closest("[data-tab]");
        if (!b) return;
        var i = b.getAttribute("data-tab");
        btns.forEach(function (x) { x.classList.toggle("on", x === b); });
        panes.forEach(function (p) { p.classList.toggle("on", p.getAttribute("data-pane") === i); });
      });
      /* פתיחת טאב מבחוץ: data-open-tab="2" */
      document.addEventListener("click", function (e) {
        var l = e.target.closest("[data-open-tab]");
        if (!l) return;
        var want = l.getAttribute("data-open-tab");
        var b2 = root.querySelector('[data-tab="' + want + '"]');
        if (!b2) return;
        e.preventDefault();
        b2.click();
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  /* ---------- 14+15. עגלה כחלון צד, מדי יעד ואפ-סייל ---------- */
  var CD = null;
  function money(c) {
    var v = c / 100;
    return "₪" + (Math.abs(v % 1) < 0.005 ? v.toFixed(0) : v.toFixed(2));
  }
  function cartDrawer() {
    var root = document.querySelector("[data-cd]");
    if (!root) return;
    var itemsEl = root.querySelector("[data-cd-items]");
    var emptyEl = root.querySelector("[data-cd-empty]");
    var footEl  = root.querySelector("[data-cd-foot]");
    var totalEl = root.querySelector("[data-cd-total]");
    var countEl = root.querySelector("[data-cd-count]");
    var shipEl  = root.querySelector("[data-cd-ship]");
    var barEl   = root.querySelector("[data-cd-ship-bar]");
    var tierEl  = root.querySelector("[data-cd-tier]");
    var goalsEl = root.querySelector("[data-cd-goals]");
    var noteEl  = root.querySelector("[data-cd-note]");
    var FREE = parseInt(root.getAttribute("data-free") || "0", 10);
    var TMIN = parseInt(root.getAttribute("data-tier-min") || "0", 10);
    var TPCT = parseFloat(root.getAttribute("data-tier-pct") || "0");
    var L = window.IROKO_CD || {};
    var BRAND = (window.IROKO_BRAND || "").trim();
    var busy = false;
    /* מדרגות ההנחה, מקור אחד לסל ולפס */
    var TIERS = [
      { min: TMIN, pct: TPCT },
      { min: parseInt(root.getAttribute("data-tier2-min") || "0", 10), pct: parseFloat(root.getAttribute("data-tier2-pct") || "0") }
    ].filter(function (x) { return x.min >= 2 && x.pct > 0; })
     .sort(function (a, b) { return a.min - b.min; });

    function clean(name) {
      if (!BRAND) return name;
      return String(name).split(BRAND).join("").replace(/s{2,}/g, " ").trim();
    }

    function open() {
      root.classList.add("on");
      root.setAttribute("aria-hidden", "false");
      document.body.classList.add("cd-open");
      startTimer();
    }
    function close() {
      root.classList.remove("on");
      root.setAttribute("aria-hidden", "true");
      document.body.classList.remove("cd-open");
    }
    CD = { open: open, close: close, refresh: load };

    function thumb(url) {
      if (!url) return "";
      return url.replace(/(\.[a-z]+)(\?|$)/i, "_240x$1$2");
    }

    function line(it) {
      var img = it.image ? '<img src="' + thumb(it.image) + '" alt="" loading="lazy">' : "";
      var opts = (it.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== "Default Title"; })
        .map(function (o) { return o.value; })
        .join(" · ");
      var disc = "";
      if (it.line_level_discount_allocations && it.line_level_discount_allocations.length) {
        disc = '<span class="cd__it-disc">' + it.line_level_discount_allocations
          .map(function (d) { return d.discount_application.title; })
          .join(", ") + "</span>";
      }
      var was = it.original_line_price > it.final_line_price
        ? "<s>" + money(it.original_line_price) + "</s>"
        : "";
      return '<div class="cd__it" data-key="' + it.key + '">' +
          '<a class="cd__it-m" href="' + it.url + '">' + img + "</a>" +
          '<div class="cd__it-b">' +
            '<p class="cd__it-n"><a href="' + it.url + '">' + clean(it.product_title) + "</a></p>" +
            (opts ? '<p class="cd__it-v">' + opts + "</p>" : "") +
            disc +
            '<div class="cd__it-r">' +
              '<span class="cd__it-q">' +
                '<button type="button" data-cd-q="-" aria-label="הפחתה">\u2212</button>' +
                "<span>" + it.quantity + "</span>" +
                '<button type="button" data-cd-q="+" aria-label="הוספה">+</button>' +
              "</span>" +
              '<span class="cd__it-p">' + money(it.final_line_price) + was + "</span>" +
            "</div>" +
            '<button type="button" class="cd__it-x" data-cd-rm>' + (L.remove || "הסרה") + "</button>" +
          "</div>" +
        "</div>";
    }

    function goals(cart) {
      var t = cart.total_price;
      if (FREE > 0 && shipEl) {
        var left = FREE - t;
        if (left > 0) {
          shipEl.innerHTML = (L.ship_pre || "עוד") + " <b>" + money(left) + "</b> " + (L.ship_post || "למשלוח חינם");
        } else {
          shipEl.innerHTML = L.ship_done || "המשלוח עלינו.";
        }
        if (barEl) {
          barEl.style.width = Math.min(100, t / FREE * 100) + "%";
          barEl.classList.toggle("done", left <= 0);
        }
      }
      if (tierEl) {
        var n = cart.item_count;
        var cur = null, nxt = null;
        TIERS.forEach(function (t2) { if (n >= t2.min) cur = t2; });
        for (var ti = 0; ti < TIERS.length; ti++) { if (n < TIERS[ti].min) { nxt = TIERS[ti]; break; } }
        if (!TIERS.length || n === 0) {
          tierEl.hidden = true;
        } else {
          tierEl.hidden = false;
          if (nxt) {
            var gap = nxt.min - n;
            tierEl.textContent = (L.tier || "הוסיפו [n] ותקבלו [pct]% הנחה")
              .replace("[n]", gap === 1 ? "פריט אחד" : gap + " פריטים")
              .replace("[pct]", nxt.pct);
            tierEl.classList.remove("hit");
          } else if (cur) {
            tierEl.textContent = (L.tier_done || "הנחת הכמות הופעלה").replace("[pct]", cur.pct);
            tierEl.classList.add("hit");
          }
        }
      }
      if (goalsEl) goalsEl.hidden = cart.item_count === 0;
    }

    function calc(cart) {
      var subEl    = root.querySelector("[data-cd-sub]");
      var lineRow  = root.querySelector("[data-cd-line-row]");
      var lineAmt  = root.querySelector("[data-cd-line-amt]");
      var row      = root.querySelector("[data-cd-disc-row]");
      var nameEl   = root.querySelector("[data-cd-disc-name]");
      var amtEl    = root.querySelector("[data-cd-disc-amt]");
      var savedEl  = root.querySelector("[data-cd-saved]");
      var savedTx  = root.querySelector("[data-cd-saved-txt]");
      if (!subEl) return;

      /* שופיפיי מחזיקה שני סוגי הנחה. הצגה של שניהם כאחד היא בדיוק
         מה שבלבל לקוחות, אז כל אחת מקבלת שורה משלה. */
      var sub = 0, lineDisc = 0;
      (cart.items || []).forEach(function (it) {
        var o = typeof it.original_line_price === "number" ? it.original_line_price : it.final_line_price;
        sub += o;
        lineDisc += Math.max(0, o - it.final_line_price);
      });
      if (!sub) sub = cart.original_total_price || cart.total_price;

      var apps = cart.cart_level_discount_applications || [];
      var cartDisc = 0;
      apps.forEach(function (a) { cartDisc += (a.total_allocated_amount || 0); });
      if (!apps.length) cartDisc = Math.max(0, sub - lineDisc - cart.total_price);

      subEl.textContent = money(sub);

      if (lineRow) {
        lineRow.hidden = lineDisc <= 0;
        if (lineAmt) lineAmt.textContent = "−" + money(lineDisc);
      }
      if (row) {
        row.hidden = cartDisc <= 0;
        if (nameEl) nameEl.textContent = apps.length ? apps.map(function (a) { return a.title; }).join(" + ") : (L.disc || "הנחה");
        if (amtEl) amtEl.textContent = "−" + money(cartDisc);
      }

      var saved = lineDisc + cartDisc;
      if (savedEl) savedEl.hidden = saved <= 0;
      if (savedTx) savedTx.textContent = (L.saved || "חסכת") + " " + money(saved);
    }

    function paint(cart) {
      var n = cart.item_count;
      if (countEl) countEl.textContent = "(" + n + ")";
      document.querySelectorAll(".ico__n, [data-cart-count]").forEach(function (e) {
        e.textContent = n;
        e.style.display = n ? "" : "none";
      });
      if (emptyEl) emptyEl.hidden = n > 0;
      if (footEl) footEl.hidden = n === 0;
      if (itemsEl) itemsEl.innerHTML = cart.items.map(line).join("");
      if (totalEl) totalEl.textContent = money(cart.total_price);
      calc(cart);
      goals(cart);
      upsell(cart);
      timerVisibility(n);
      nudge(cart);
    }

    /* הצעות: פריט שנכנס לסל יורד ומתחלף בבא בתור */
    function upsell(cart) {
      var pool = root.querySelectorAll(".cd__up-i");
      if (!pool.length) return;
      var ids = (cart.items || []).map(function (i) { return String(i.product_id); });
      var shown = 0, MAXN = 6;
      pool.forEach(function (el) {
        var mine = String(el.getAttribute("data-cd-up"));
        var used = ids.indexOf(mine) !== -1;
        if (!used && shown < MAXN) {
          el.hidden = false;
          shown++;
        } else {
          el.hidden = true;
          var sz = el.querySelector(".cd__up-sz");
          if (sz) sz.setAttribute("hidden", "");
          var pk = el.querySelector("[data-cd-pick]");
          if (pk) pk.classList.remove("on");
        }
      });
      var wrap = root.querySelector(".cd__up");
      if (wrap) wrap.hidden = shown === 0;
    }

    /* טיימר: אין סל, אין ספירה */
    function timerVisibility(n) {
      var t = root.querySelector("[data-cd-timer]");
      if (!t) return;
      if (n === 0) {
        t.hidden = true;
        timerStarted = false;
        try { sessionStorage.removeItem("iroko_cd_deadline"); } catch (e) {}
      } else {
        t.hidden = false;
        startTimer();
      }
    }

    var nudgeEl = document.querySelector("[data-tiernudge]");
    var nudgeTx = document.querySelector("[data-tiernudge-t]");
    var lastNudge = -1, nudgeTimer = null, nudgeOff = false;
    if (nudgeEl) {
      var xb = nudgeEl.querySelector("[data-tiernudge-x]");
      if (xb) xb.addEventListener("click", function () {
        nudgeOff = true;
        nudgeEl.classList.remove("on");
        setTimeout(function () { nudgeEl.hidden = true; }, 400);
      });
    }
    function nudge(cart) {
      if (!nudgeEl || !nudgeTx || !TIERS.length || nudgeOff) return;
      var n = cart.item_count;
      if (n < 1 || root.classList.contains("on")) { hideNudge(); return; }
      var nxt = null;
      for (var i = 0; i < TIERS.length; i++) { if (n < TIERS[i].min) { nxt = TIERS[i]; break; } }
      if (!nxt) { hideNudge(); return; }
      var gap = nxt.min - n;
      if (gap === lastNudge && nudgeEl.classList.contains("on")) return;
      lastNudge = gap;
      nudgeTx.textContent = (L.nudge || "עוד [n] ואתם מקבלים [pct]% הנחה")
        .replace("[n]", gap === 1 ? "פריט אחד" : gap + " פריטים")
        .replace("[pct]", nxt.pct);
      nudgeEl.hidden = false;
      requestAnimationFrame(function () { nudgeEl.classList.add("on"); });
      clearTimeout(nudgeTimer);
      nudgeTimer = setTimeout(hideNudge, 7000);
    }
    function hideNudge() {
      if (!nudgeEl) return;
      nudgeEl.classList.remove("on");
      clearTimeout(nudgeTimer);
      nudgeTimer = setTimeout(function () { nudgeEl.hidden = true; }, 400);
    }

    function load() {
      return fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function (c) { paint(c); return c; })
        .catch(function () {
          /* בקשה שנכשלה לא אמורה להשאיר פאנל הצעות ריק */
          upsell({ items: [] });
          return null;
        });
    }

    function change(body) {
      if (busy) return Promise.resolve();
      busy = true;
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); })
        .then(function (c) { paint(c); })
        .catch(function () {})
        .finally(function () { busy = false; });
    }

    function add(id, qty) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () { return load(); })
        .then(function () { open(); });
    }
    window.IROKO_ADD = add;

    var timerStarted = false;
    function startTimer() {
      var t = root.querySelector("[data-cd-timer]");
      if (!t || timerStarted) return;
      timerStarted = true;
      var mins = parseInt(t.getAttribute("data-mins") || "15", 10);
      var key = "iroko_cd_deadline";
      var end = 0;
      try { end = parseInt(sessionStorage.getItem(key) || "0", 10); } catch (e) {}
      if (!end || end < Date.now()) {
        end = Date.now() + mins * 60000;
        try { sessionStorage.setItem(key, String(end)); } catch (e) {}
      }
      var clock = t.querySelector("[data-cd-clock]");
      (function run() {
        var left = Math.max(0, end - Date.now());
        var m = Math.floor(left / 60000), s = Math.floor(left / 1000) % 60;
        if (clock) clock.textContent = m + ":" + (s < 10 ? "0" + s : s);
        if (left <= 0) { t.hidden = true; return; }
        setTimeout(run, 1000);
      })();
    }

    root.addEventListener("click", function (e) {
      if (e.target.classList.contains("cd__bg") || e.target.closest("[data-cd-close]")) {
        e.preventDefault();
        close();
        return;
      }
      var q = e.target.closest("[data-cd-q]");
      if (q) {
        var row = q.closest(".cd__it");
        var cur = parseInt(row.querySelector(".cd__it-q span").textContent, 10) || 1;
        var next = q.getAttribute("data-cd-q") === "+" ? cur + 1 : cur - 1;
        change({ id: row.getAttribute("data-key"), quantity: Math.max(0, next) });
        return;
      }
      var rm = e.target.closest("[data-cd-rm]");
      if (rm) {
        change({ id: rm.closest(".cd__it").getAttribute("data-key"), quantity: 0 });
        return;
      }
      var pick = e.target.closest("[data-cd-pick]");
      if (pick) {
        e.preventDefault();
        var card = pick.closest(".cd__up-i");
        var sz = card.querySelector(".cd__up-sz");
        var isOpen = sz && !sz.hasAttribute("hidden");
        root.querySelectorAll(".cd__up-sz").forEach(function (x) { x.setAttribute("hidden", ""); });
        root.querySelectorAll("[data-cd-pick]").forEach(function (x) { x.classList.remove("on"); });
        if (sz && !isOpen) { sz.removeAttribute("hidden"); pick.classList.add("on"); }
        return;
      }
      var up = e.target.closest("[data-cd-add]");
      if (up) { up.disabled = true; add(up.getAttribute("data-cd-add"), 1); }
    });

    if (noteEl) {
      var nt;
      noteEl.addEventListener("input", function () {
        clearTimeout(nt);
        nt = setTimeout(function () {
          fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ note: noteEl.value })
          }).catch(function () {});
        }, 700);
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && root.classList.contains("on")) close();
    });

    load();

    document.addEventListener("click", function (e) {
      var a = e.target.closest('a[href$="/cart"], [data-cd-open]');
      if (!a || a.closest("[data-cd]")) return;
      e.preventDefault();
      open();
      load();
    });

    document.addEventListener("submit", function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var old = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "…"; }
      fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () { return load(); })
        .then(function () { open(); })
        .catch(function () {})
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = old; } });
    });

    load();
  }

  /* ---------- טופס ביקורת ---------- */
  function reviewForm() {
    var box = document.querySelector("[data-revform]");
    if (!box) return;
    var stars = box.querySelector("[data-rev-stars]");
    var hidden = box.querySelector("[data-rev-rating]");

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-rev-open]")) {
        e.preventDefault();
        box.classList.add("on");
        box.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });

    if (stars && hidden) {
      var btns = stars.querySelectorAll("[data-star]");
      function paint(n) {
        btns.forEach(function (b, i) { b.classList.toggle("on", i < n); });
      }
      btns.forEach(function (b) {
        b.addEventListener("mouseenter", function () {
          var n = parseInt(b.getAttribute("data-star"), 10);
          btns.forEach(function (x, i) { x.classList.toggle("hot", i < n); });
        });
        b.addEventListener("click", function () {
          var n = parseInt(b.getAttribute("data-star"), 10);
          hidden.value = n;
          paint(n);
        });
      });
      stars.addEventListener("mouseleave", function () {
        btns.forEach(function (x) { x.classList.remove("hot"); });
      });
      paint(parseInt(hidden.value, 10) || 5);
    }

    /* אם הטופס נשלח, להשאיר אותו פתוח כדי שיראו את התודה */
    if (box.querySelector(".revform__ok.on")) box.classList.add("on");
  }

  /* ---------- נייד: נגיעה בתמונה חושפת את המידות ---------- */
  /* 4. מידה עם כמה גזרות פותחת את שורת הגזרות שלה */
  /* 1. מגירת הניווט נפתחת קבוצה־קבוצה */
  function drawerNav() {
    var nav = document.querySelector("[data-drawer-nav]");
    if (!nav) return;
    nav.addEventListener("click", function (e) {
      var b = e.target.closest("[data-drawer-toggle]");
      if (!b) return;
      e.preventDefault();
      var sub = b.parentNode.querySelector(".sub");
      if (!sub) return;
      var open = !sub.hasAttribute("hidden");
      nav.querySelectorAll(".sub").forEach(function (s) { s.setAttribute("hidden", ""); });
      nav.querySelectorAll("[data-drawer-toggle]").forEach(function (x) {
        x.setAttribute("aria-expanded", "false");
        x.classList.remove("on");
      });
      if (!open) {
        sub.removeAttribute("hidden");
        b.setAttribute("aria-expanded", "true");
        b.classList.add("on");
      }
    });
  }

  /* 1. קטגוריה עם תתי־קטגוריות פותחת שורה משלה מתחת לסרגל */
  function colPills() {
    var nav = document.querySelector("[data-colpills]");
    if (!nav) return;
    var subs = document.querySelectorAll("[data-colsub]");
    nav.addEventListener("click", function (e) {
      var b = e.target.closest("[data-colsub-open]");
      if (!b) return;
      e.preventDefault();
      var sub = document.querySelector('[data-colsub="' + b.getAttribute("data-colsub-open") + '"]');
      var open = sub && !sub.hidden;
      subs.forEach(function (s) { s.hidden = true; });
      nav.querySelectorAll("[data-colsub-open]").forEach(function (x) {
        x.setAttribute("aria-expanded", "false");
        x.classList.remove("open");
      });
      if (sub && !open) {
        sub.hidden = false;
        b.setAttribute("aria-expanded", "true");
        b.classList.add("open");
      }
    });
    /* הקטגוריה הפעילה נגללת לתוך הסרגל, בלי להזיז את הדף */
    function center(row) {
      var on = row && row.querySelector(".on");
      if (!on) return;
      var a = on.getBoundingClientRect(), r = row.getBoundingClientRect();
      row.scrollLeft += (a.left + a.width / 2) - (r.left + r.width / 2);
    }
    center(nav);
    subs.forEach(function (s) { if (!s.hidden) center(s.querySelector(".colsub__in")); });
  }

  /* 5. הוספה לסל מהכרטיס: בוחרים מידה (וגזרה), ורק כפתור ההוספה מוסיף */
  function cardBuy() {
    function bar(card) { return card.querySelector("[data-card-buy]"); }
    function closeBuy(card) {
      if (!card) return;
      var b = bar(card);
      if (b) b.hidden = true;
      card.classList.remove("buying");
      delete card.dataset.buyMode;
      card.querySelectorAll("[data-sz-pick]").forEach(function (x) {
        x.classList.remove("on");
        x.setAttribute("aria-pressed", "false");
      });
    }
    function closeOthers(keep) {
      document.querySelectorAll(".card.buying").forEach(function (c) { if (c !== keep) closeBuy(c); });
    }
    function pickFit(fit) {
      var b = fit.closest("[data-card-buy]");
      b.querySelectorAll("[data-fit-id]").forEach(function (f) { f.classList.toggle("on", f === fit); });
      var add = b.querySelector("[data-buy-add]");
      add.disabled = false;
      add.setAttribute("data-id", fit.getAttribute("data-fit-id"));
      var lab = b.querySelector("[data-buy-label]");
      var name = fit.getAttribute("data-fit-name");
      var base = lab.getAttribute("data-base") || "";
      lab.textContent = base && name ? base + " · " + name : (base || name);
    }

    function addNow(btn, id) {
      btn.classList.add("busy");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      }).then(function () {
        btn.classList.remove("busy");
        if (CD) CD.refresh().then(function () { CD.open(); });
        else toast("נוסף לסל");
      }).catch(function (err) {
        btn.classList.remove("busy");
        toast((err && (err.description || err.message)) || "הפריט לא נוסף לסל");
      });
    }
    /* כל המידות הזמינות בחלונית אחת, בלי לחפש את סרגל המידות */
    function openAll(card) {
      if (card.classList.contains("buying") && card.dataset.buyMode === "all") { closeBuy(card); return; }
      closeOthers(card);
      card.querySelectorAll("[data-sz-pick]").forEach(function (x) { x.classList.remove("on"); x.setAttribute("aria-pressed", "false"); });
      var b = bar(card);
      if (!b) return;
      var fitsEl = b.querySelector("[data-buy-fits]");
      var add = b.querySelector("[data-buy-add]");
      var lab = b.querySelector("[data-buy-label]");
      fitsEl.innerHTML = "";
      card.querySelectorAll("[data-sz]").forEach(function (sz) {
        var tpl = sz.querySelector("template[data-fits]");
        if (!tpl) return;
        var tmp = document.createElement("div");
        tmp.innerHTML = tpl.innerHTML;
        tmp.querySelectorAll("[data-fit-id]").forEach(function (f) {
          var fit = f.getAttribute("data-fit-name");
          var full = sz.getAttribute("data-sz") + (fit ? " " + fit : "");
          f.textContent = full;
          f.setAttribute("data-fit-name", "מידה " + full);
          fitsEl.appendChild(f);
        });
      });
      var avail = [].slice.call(fitsEl.querySelectorAll("[data-fit-id]:not([disabled])"));
      lab.setAttribute("data-base", "");
      add.disabled = true;
      add.removeAttribute("data-id");
      fitsEl.hidden = false;
      if (avail.length === 1) pickFit(avail[0]);
      else lab.textContent = "בחרו מידה";
      b.hidden = false;
      card.classList.add("buying");
      card.dataset.buyMode = "all";
    }

    document.addEventListener("click", function (e) {
      var plus = e.target.closest("[data-card-add]");
      if (plus) {
        e.preventDefault();
        e.stopPropagation();
        var pid = plus.getAttribute("data-id");
        if (pid) addNow(plus, pid);
        else openAll(plus.closest("[data-card]"));
        return;
      }
      var pick = e.target.closest("[data-sz-pick]");
      if (pick) {
        e.preventDefault();
        e.stopPropagation();
        var card = pick.closest("[data-card]");
        /* לחיצה נוספת על אותה מידה סוגרת, לא מוסיפה */
        if (pick.classList.contains("on")) { closeBuy(card); return; }
        closeOthers(card);
        card.querySelectorAll("[data-sz-pick]").forEach(function (x) {
          var on = x === pick;
          x.classList.toggle("on", on);
          x.setAttribute("aria-pressed", on ? "true" : "false");
        });
        var b = bar(card);
        var sz = pick.closest("[data-sz]");
        var fitsEl = b.querySelector("[data-buy-fits]");
        var add = b.querySelector("[data-buy-add]");
        var lab = b.querySelector("[data-buy-label]");
        var tpl = sz.querySelector("template[data-fits]");
        fitsEl.innerHTML = tpl ? tpl.innerHTML : "";
        var fits = [].slice.call(fitsEl.querySelectorAll("[data-fit-id]"));
        var avail = fits.filter(function (f) { return !f.disabled; });
        var base = "מידה " + sz.getAttribute("data-sz");
        lab.setAttribute("data-base", base);
        lab.textContent = base;
        add.disabled = true;
        add.removeAttribute("data-id");
        if (fits.length <= 1) {
          fitsEl.hidden = true;
          if (avail[0]) pickFit(avail[0]);
        } else {
          fitsEl.hidden = false;
          if (avail.length === 1) pickFit(avail[0]);
          else lab.textContent = base + " · בחרו גזרה";
        }
        b.hidden = false;
        card.classList.add("buying");
        card.dataset.buyMode = "size";
        return;
      }

      var fit = e.target.closest("[data-buy-fits] [data-fit-id]");
      if (fit) {
        e.preventDefault();
        e.stopPropagation();
        if (!fit.disabled) pickFit(fit);
        return;
      }

      var x = e.target.closest("[data-buy-close]");
      if (x) {
        e.preventDefault();
        e.stopPropagation();
        closeBuy(x.closest("[data-card]"));
        return;
      }

      var addb = e.target.closest("[data-buy-add]");
      if (addb) {
        e.preventDefault();
        e.stopPropagation();
        var id = addb.getAttribute("data-id");
        if (!id || addb.disabled) return;
        var card2 = addb.closest("[data-card]");
        var old = addb.textContent;
        addb.disabled = true;
        addb.textContent = "…";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        }).then(function (r) {
          return r.json().then(function (j) { if (!r.ok) throw j; return j; });
        }).then(function () {
          addb.textContent = old;
          closeBuy(card2);
          if (CD) CD.refresh().then(function () { CD.open(); });
          else toast("נוסף לסל");
        }).catch(function (err) {
          addb.textContent = old;
          addb.disabled = false;
          toast((err && err.description) || "לא הצלחנו להוסיף. נסו שוב.");
        });
        return;
      }

      if (!e.target.closest("[data-card]")) closeOthers(null);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeOthers(null); });
  }

  /* 8. שורת ההנחה בדף המוצר פותחת וסוגרת את הבאנדל */
  /* 4 · 7. בדף המוצר: בוחרים מידה, ורק אז נפתחות הגזרות שלה */
  function sizeGroups() {
    var root = document.querySelector("[data-pdp]");
    if (!root) return;
    var groups = root.querySelector("[data-size-groups]");
    var vals = root.querySelector("[data-size-vals]");
    if (!groups || !vals) return;
    var box = vals.closest(".opt");

    function sync() {
      groups.querySelectorAll("[data-size-group]").forEach(function (b) {
        var g = b.getAttribute("data-size-group");
        var any = false;
        vals.querySelectorAll('.chip[data-group="' + g + '"]').forEach(function (c) {
          if (!c.classList.contains("off")) any = true;
        });
        b.classList.toggle("off", !any);
      });
    }
    function show(g, pick) {
      groups.querySelectorAll("[data-size-group]").forEach(function (b) {
        b.classList.toggle("on", b.getAttribute("data-size-group") === g);
      });
      var n = 0, first = null;
      vals.querySelectorAll(".chip").forEach(function (c) {
        var m = c.getAttribute("data-group") === g;
        c.hidden = !m;
        if (m) {
          n++;
          if (!first && !c.classList.contains("off")) first = c;
        }
      });
      box.classList.add("picked");
      box.classList.toggle("one-fit", n < 2);
      if (pick && first) first.click();
      setTimeout(sync, 0);
    }

    function collapse() {
      groups.querySelectorAll("[data-size-group]").forEach(function (b) { b.classList.remove("on"); });
      vals.querySelectorAll(".chip").forEach(function (c) { c.hidden = true; });
      box.classList.remove("picked", "one-fit");
    }
    groups.addEventListener("click", function (e) {
      var b = e.target.closest("[data-size-group]");
      if (!b) return;
      /* מידה שכל הגזרות שלה אזלו לא נפתחת */
      if (b.classList.contains("off")) return;
      /* לחיצה שנייה על אותה מידה מקפלת את הגזרות בחזרה */
      if (b.classList.contains("on")) { collapse(); return; }
      show(b.getAttribute("data-size-group"), true);
    });
    vals.addEventListener("click", function () { setTimeout(sync, 0); });
    document.addEventListener("iroko:variant", sync);

    var on = vals.querySelector(".chip.on");
    if (on) show(on.getAttribute("data-group"), false);
    else {
      vals.querySelectorAll(".chip").forEach(function (c) { c.hidden = true; });
      box.classList.remove("picked");
    }
    setTimeout(sync, 0);
  }

  function deal() {
    var wrap = document.querySelector("[data-dealwrap]");
    var bar = document.querySelector("[data-deal-open]");
    if (!wrap || !bar) return;
    bar.addEventListener("click", function () {
      var open = !wrap.hasAttribute("hidden");
      if (open) {
        wrap.setAttribute("hidden", "");
      } else {
        wrap.removeAttribute("hidden");
      }
      bar.setAttribute("aria-expanded", open ? "false" : "true");
      bar.classList.toggle("on", !open);
    });
  }

  /* ---------- כרטיסים: הלשוניות והמידות נחשפים כשמגיעים אליהם ---------- */
  function cardsSeen() {
    var left = [].slice.call(document.querySelectorAll(".card"));
    if (!left.length) return;

    function pass() {
      var vh = window.innerHeight || 800;
      left = left.filter(function (c) {
        var r = c.getBoundingClientRect();
        if (r.width > 0 && r.bottom > 0 && r.top < vh * 0.88) {
          c.classList.add("seen");
          return false;
        }
        return true;
      });
      if (!left.length) {
        window.removeEventListener("scroll", tick);
        window.removeEventListener("resize", tick);
        document.removeEventListener("click", tick);
      }
    }
    var queued = false;
    function tick() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; pass(); });
    }
    window.addEventListener("scroll", tick, { passive: true });
    window.addEventListener("resize", tick, { passive: true });
    document.addEventListener("click", tick);
    /* הפריים הראשון נותן ל-CSS להחיל את מצב ההסתרה, כדי שגם הכרטיסים
       שכבר על המסך ייכנסו באנימציה ולא יופיעו מוכנים */
    requestAnimationFrame(tick);
    setTimeout(pass, 900);
  }

  /* ---------- 2. שעון הדרופ השבועי ---------- */
  function dropClock() {
    var root = document.querySelector("[data-drop]");
    if (!root) return;
    var day = parseInt(root.getAttribute("data-drop-day") || "5", 10);
    var hour = parseInt(root.getAttribute("data-drop-hour") || "12", 10);
    var win = parseInt(root.getAttribute("data-drop-window") || "6", 10);
    var clock = root.querySelector("[data-drop-clock]");
    if (!clock) return;
    var bs = clock.querySelectorAll("b");
    var titleEl = root.querySelector("[data-drop-title]");
    var subEl = root.querySelector("[data-drop-sub]");
    var t0 = titleEl ? titleEl.textContent : "";
    var s0 = subEl ? subEl.textContent : "";
    var tLive = root.getAttribute("data-live-title") || "הדרופ באוויר עכשיו";
    var sLive = root.getAttribute("data-live-sub") || "הפריטים החדשים עלו. כל אחד ביחידה אחת.";

    function nextDrop(now) {
      var d = new Date(now);
      d.setHours(hour, 0, 0, 0);
      var diff = (day - d.getDay() + 7) % 7;
      d.setDate(d.getDate() + diff);
      if (d.getTime() <= now) d.setDate(d.getDate() + 7);
      return d.getTime();
    }
    function lastDrop(now) { return nextDrop(now) - 7 * 864e5; }

    (function run() {
      var now = Date.now();
      var since = now - lastDrop(now);
      var live = since >= 0 && since < win * 36e5;

      root.classList.toggle("dropbar--live", live);
      if (titleEl) titleEl.textContent = live ? tLive : t0;
      if (subEl) subEl.textContent = live ? sLive : s0;

      var left = live ? (win * 36e5 - since) : (nextDrop(now) - now);
      var d = Math.floor(left / 864e5),
          h = Math.floor(left / 36e5) % 24,
          m = Math.floor(left / 6e4) % 60,
          s = Math.floor(left / 1e3) % 60;
      var v = [d, h, m, s];
      bs.forEach(function (b, i) {
        var x = v[i];
        b.textContent = x < 10 ? "0" + x : String(x);
      });
      setTimeout(run, 1000);
    })();
  }

  /* ---------- 2. פופ-אפ מקוריות בדף מוצר ---------- */
  function authPop() {
    var el = document.querySelector("[data-auth]");
    if (!el) return;
    var every = parseInt(el.getAttribute("data-auth-every") || "1", 10);
    var delay = parseInt(el.getAttribute("data-auth-delay") || "6", 10) * 1000;
    var KEY = "iroko_auth_views";

    var seen = 0;
    try { seen = parseInt(sessionStorage.getItem(KEY) || "0", 10) || 0; } catch (e) {}
    seen++;
    try { sessionStorage.setItem(KEY, String(seen)); } catch (e) {}
    if (every > 1 && seen % every !== 0) return;

    function close() {
      el.classList.remove("on");
      document.body.classList.remove("cd-open");
    }
    setTimeout(function () {
      if (document.querySelector(".cd.on")) return;   /* לא לחתוך פתיחת עגלה */
      el.classList.add("on");
    }, delay);

    el.addEventListener("click", function (e) {
      if (e.target === el || e.target.closest("[data-auth-close]")) { e.preventDefault(); close(); }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && el.classList.contains("on")) close();
    });
  }

  /* ---------- 18. תפריט נגישות ---------- */
  function a11y() {
    var root = document.querySelector("[data-a11y]");
    if (!root) return;
    var KEY = "iroko_a11y";
    var html = document.documentElement;
    var toggles = [].slice.call(document.querySelectorAll("[data-a11y-toggle]"));
    var panel = root.querySelector(".a11y__panel");
    var btn = toggles[0];
    function visibleToggle() {
      return toggles.filter(function (t) { return t.offsetParent !== null; })[0] || btn;
    }
    var FLAGS = ["contrast", "gray", "links", "font", "motion", "cursor", "focus"];
    var st = {};
    try { st = JSON.parse(localStorage.getItem(KEY) || "{}") || {}; } catch (e) { st = {}; }

    function save() { try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} }
    function apply() {
      html.classList.toggle("a11y-fs1", st.fs === 1);
      html.classList.toggle("a11y-fs2", st.fs === 2);
      FLAGS.forEach(function (k) { html.classList.toggle("a11y-" + k, !!st[k]); });
      root.querySelectorAll("[data-a11y]").forEach(function (b) {
        var k = b.getAttribute("data-a11y");
        var on = k === "fs" ? !!st.fs : !!st[k];
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      var lvl = root.querySelector("[data-a11y-lvl]");
      if (lvl) lvl.textContent = st.fs ? (st.fs === 1 ? "+1" : "+2") : "";
      document.querySelectorAll("video").forEach(function (v) {
        if (st.motion) { try { v.pause(); } catch (e) {} }
        else if (v.autoplay && v.paused) { v.play().catch(function () {}); }
      });
    }
    if (!btn || !panel) return;
    function open() {
      panel.hidden = false;
      toggles.forEach(function (t) { t.setAttribute("aria-expanded", "true"); });
      var f = panel.querySelector("button"); if (f) f.focus();
    }
    function close() {
      panel.hidden = true;
      toggles.forEach(function (t) { t.setAttribute("aria-expanded", "false"); });
    }

    toggles.forEach(function (t) {
      t.addEventListener("click", function (e) { e.stopPropagation(); if (panel.hidden) open(); else close(); });
    });
    root.addEventListener("click", function (e) {
      if (e.target.closest("[data-a11y-close]")) { close(); visibleToggle().focus(); return; }
      if (e.target.closest("[data-a11y-reset]")) { st = {}; save(); apply(); return; }
      var b = e.target.closest(".a11y__grid [data-a11y]");
      if (!b) return;
      var k = b.getAttribute("data-a11y");
      if (k === "fs") st.fs = ((st.fs || 0) + 1) % 3;
      else st[k] = !st[k];
      save();
      apply();
    });
    document.addEventListener("click", function (e) {
      if (!panel.hidden && !root.contains(e.target) && !e.target.closest("[data-a11y-toggle]")) close();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !panel.hidden) { close(); visibleToggle().focus(); } });
    apply();
  }

  /* ---------- וידאו אוטומטי ----------
     בחלק מהמכשירים (אייפון במצב חיסכון בסוללה, אנדרואיד עם חיסכון בנתונים, דפדפנים בתוך אינסטגרם/פייסבוק)
     הדפדפן חוסם הפעלה אוטומטית והווידאו נשאר קפוא. מנסים שוב כשהוא נכנס למסך, כשחוזרים ללשונית,
     ובמגע הראשון של הגולש בדף (מגע נחשב אישור להפעלה). עד אז מוצגת תמונת הפוסטר, בלי כפתור הפעלה. */
  window.irokoPlay = function (v) {
    v.muted = true; v.defaultMuted = true; v.setAttribute("muted", ""); v.playsInline = true;
    var p = v.play();
    if (p && p.then) p.then(function () { v.classList.remove("is-blocked"); }, function () { v.classList.add("is-blocked"); });
  };
  function autoVideos() {
    var vids = [].slice.call(document.querySelectorAll("video[autoplay]"));
    if (!vids.length) return;
    function visible(v) { var r = v.getBoundingClientRect(); return r.bottom > 0 && r.top < (window.innerHeight || 800) && r.width > 0; }
    function tryAll() { vids.forEach(function (v) { if (v.paused && visible(v)) window.irokoPlay(v); }); }
    vids.forEach(function (v) {
      if (v._irokoAuto) return; v._irokoAuto = true;
      v.addEventListener("canplay", function () { if (v.paused && visible(v)) window.irokoPlay(v); });
    });
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && e.target.paused) window.irokoPlay(e.target); }); });
      vids.forEach(function (v) { io.observe(v); });
    }
    if (!window._irokoAutoBound) {
      window._irokoAutoBound = true;
      ["touchend", "click", "keydown"].forEach(function (ev) { document.addEventListener(ev, tryAll, { passive: true }); });
      document.addEventListener("visibilitychange", function () { if (!document.hidden) tryAll(); });
      window.addEventListener("pageshow", tryAll);
    }
    tryAll();
  }

  function boot() {
    scanRise(); scanReveal(); viewToggle(); pdpViews(); popup(); tabs(); cartDrawer(); reviewForm(); cardsSeen(); drawerNav(); colPills(); cardGallery(); railSwipe(); cardBuy(); deal(); dropClock(); authPop(); header(); navFit(); announce(); drawer(); drops(); product(); sizeGroups(); quantities();
    quickAdd(); wishlist(); rails(); liveCount(); bundle(); stickyBar(); sizeFinder();
    parallax(); chapters(); a11y(); autoVideos();
    // התחלה נקייה של הקרוסלות (RTL/LTR)
    requestAnimationFrame(function () {
      document.querySelectorAll(".row__track, .pdp__gal, .look2__track").forEach(function (t) { t.scrollLeft = 0; });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
